import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { filter, take } from 'rxjs/operators';

export function roleGuard(requiredRole: string): CanActivateFn {
  return async () => {
    const authService = inject(MsalService);
    const broadcast = inject(MsalBroadcastService);
    const router = inject(Router);

    // Wait for auth to complete if no account yet
    let account = authService.instance.getActiveAccount()
      ?? authService.instance.getAllAccounts()[0];

    if (!account) {
      try {
        await firstValueFrom(
          broadcast.inProgress$.pipe(
            filter(status => status === 'none'),
            take(1)
          )
        );
        account = authService.instance.getActiveAccount()
          ?? authService.instance.getAllAccounts()[0];
      } catch {
        return router.createUrlTree(['/login-failed']);
      }
    }

    if (!account) {
      return router.createUrlTree(['/login-failed']);
    }

    const claims = account.idTokenClaims as Record<string, unknown> | undefined;
    const roles = claims?.['roles'] as string[] | undefined;

    if (roles?.includes(requiredRole)) {
      return true;
    }

    return router.createUrlTree(['/unauthorized']);
  };
}
